import { Map } from "immutable";
import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { InjectedFormProps } from "redux-form";
import { Field, reduxForm } from "redux-form/immutable";
import UpCustomerSettingsButtonFooter from "../../../../../components/UpCustomerSettingsButtonFooter";
import UpInputWithLabel from "../../../../../components/UpInputWithLabel";
import { multiSelectBoxNonImmutable } from "../../../../../components/up-styled-react-select";
import { selectBox } from "../../../../CustomerSettings/EmailSignature/input-fields";
import { IntegrationInfoList, IntegrationType } from "../../types";
import { CleverReachListsSettings } from "./types";

type CleverReachSettingsFormComponentProps = {
  saving: boolean;
  handleSave: (values: CleverReachListsSettings) => void;
  listOptions: IntegrationInfoList[];
};

const CleverReachSettingsFormComponent = (
  props: CleverReachSettingsFormComponentProps &
    InjectedFormProps<Map<unknown, unknown>, CleverReachSettingsFormComponentProps>
) => {
  const { pristine, invalid, handleSave, handleSubmit, reset, listOptions, saving } = props;

  const intl = useIntl();

  const options = useMemo(
    () => listOptions.map((l) => ({ label: l.name, value: l.id })),
    [listOptions]
  );

  return (
    <div>
      <Field
        name="list"
        component={selectBox}
        type="text"
        label={
          <FormattedMessage
            id={`containers.Integrations.cleverreach.list.label`}
            defaultMessage="List to add new optins"
          />
        }
        placeholder="Select List"
        infoText={intl.formatMessage(
          {
            id: `containers.Integrations.list.infoText`,
            defaultMessage:
              "After successfully connected to {integration} new optins will be added to this list. After the creation of a new list in the connected {integration} Account, please, delete this configuration line and re-connect again."
          },
          {
            integration: IntegrationType.CLEVERREACH
          }
        )}
        width="100%"
        options={options}
      />

      <UpInputWithLabel
        label={
          <FormattedMessage
            id={`containers.Integrations.cleverreach.whitelist`}
            defaultMessage="Whitelist"
          />
        }
      >
        <Field
          name="whitelist"
          component={multiSelectBoxNonImmutable}
          type="text"
          placeholder="Select Whitelist"
          width="100%"
          options={options}
        />
      </UpInputWithLabel>

      <UpInputWithLabel
        label={
          <FormattedMessage
            id={`containers.Integrations.cleverreach.blacklist`}
            defaultMessage="Blacklist"
          />
        }
      >
        <Field
          name="blacklist"
          component={multiSelectBoxNonImmutable}
          type="text"
          placeholder="Select Blacklist"
          width="100%"
          options={options}
        />
      </UpInputWithLabel>

      <UpCustomerSettingsButtonFooter
        saveButtonDisabled={pristine || invalid}
        resetButtonDisabled={pristine}
        saveButtonOnClick={handleSubmit((values) => handleSave(values.toJS()))}
        resetButtonOnClick={reset}
        saving={saving}
      />
    </div>
  );
};

export const CleverReachSettingsForm = reduxForm<
  Map<unknown, unknown>,
  CleverReachSettingsFormComponentProps
>({
  form: `IntegrationForm_cleverreach`,
  enableReinitialize: true
})(CleverReachSettingsFormComponent);
